enum FormQuestionsFilterType {
  Equals = 'equals',
  DoesNotEqual = 'does not equal',
  LessThan = 'less then',
  MoreThan = 'more then',
}

export default FormQuestionsFilterType;
